function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconShareRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 12a3.97 3.97 0 013.001 1.381l11.09-5.544A4 4 0 1125 11a3.972 3.972 0 01-3.001-1.381l-11.09 5.544c.058.271.091.55.091.837 0 .287-.033.566-.091.837l11.09 5.544A3.973 3.973 0 0125 21a4 4 0 11-4 4c0-.287.033-.566.091-.837l-11.09-5.544A3.975 3.975 0 017 20a4 4 0 010-8z",
    fill: props.color
  }));
}

export default SvgIconShareRexFilled;